import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Chính Sách Quyền Riêng Tư</h2>
            <p><strong>CHÍNH SÁCH QUYỀN RIÊNG TƯ DREAMEHOME</strong></p>
            <p><strong>Lời Nói Đầu</strong></p>
            <p>Nghiệp vụ của "Dreamehome" được điều hành bởi Công ty TNHH Dreame Innovation Technology (Suzhou) và các công ty
                liên kết của nó (sau đây gọi là "Chúng tôi" hoặc "Dreame"), đây là nền tảng (hoặc dịch vụ) cung cấp cho bạn các
                dịch
                vụ quản lý và điều khiển thiết bị phần cứng thông minh. Chúng tôi hiểu rất rõ tầm quan trọng của thông tin cá
                nhân
                đối với bạn, đồng thời sẽ cố gắng hết sức để bảo vệ an toàn thông tin cá nhân của bạn. Chúng tôi sẽ áp dụng các
                biện
                pháp bảo mật tương ứng để bảo vệ thông tin cá nhân của bạn theo các tiêu chuẩn bảo mật được ngành công nhận</p>
            <p>Do đó, mong bạn vui lòng đọc và hiểu kỹ “Chính Sách Quyền Riêng Tư Dreamehome” này trước khi sử dụng sản phẩm
                (hoặc
                dịch vụ) của chúng tôi</p>
            <p>Nếu bạn là trẻ vị thành niên, vui lòng sử dụng ứng dụng này với sự đồng ý của người giám hộ và đồng ý với các
                điều
                khoản dịch vụ ứng dụng có liên quan.</p>
            <p>Chính sách quyền riêng tư này được xây dựng với sự cân nhắc đầy đủ nhu cầu của bạn. Điều quan trọng là bạn phải
                hiểu đầy đủ các quy trình thu thập và sử dụng thông tin cá nhân của chúng tôi, đồng thời đảm bảo rằng bạn là
                người
                kiểm soát cuối cùng những thông tin cá nhân đã cung cấp cho chúng tôi. Chính sách quyền riêng tư này quy định
                cách
                chúng tôi thu thập, sử dụng, tiết lộ, xử lý và lưu trữ thông tin mà bạn cung cấp khi bạn sử dụng ứng dụng của
                chúng
                tôi. Chúng tôi sẽ tuân thủ nghiêm ngặt chính sách quyền riêng tư này khi sử dụng các thông tin mà bạn cung cấp.
            </p>
            <p>Chính sách quyền riêng tư này sẽ giúp bạn hiểu những điều sau:</p>
            <p>1. Chúng tôi thu thập những thông tin gì và sử dụng chúng như thế nào</p>
            <p>2. Cách chúng tôi sử dụng cookie và các công nghệ tương tự</p>
            <p>3. Cách chúng tôi ủy thác việc xử lý, chia sẻ, chuyển giao và tiết lộ công khai thông tin cá nhân của bạn</p>
            <p>4. Cách chúng tôi lưu trữ và bảo vệ thông tin cá nhân của bạn</p>
            <p>5. Quyền lợi của bạn</p>
            <p>6. Truyền dữ liệu xuyên biên giới</p>
            <p>7. Liên hệ với chúng tôi</p>
            <p>8. Cách cập nhật chính sách quyền riêng tư này</p>
            <p>Bảng 1: Thông tin chi tiết về SDK của bên thứ ba</p>
            <p>Mục tiêu cuối cùng của chúng tôi là mang đến cho bạn trải nghiệm người dùng tốt nhất. Nếu bạn có bất kỳ câu hỏi
                nào
                đối với chính sách quyền riêng tư này, chúng tôi đã thiết lập một bộ phận và nhân viên chuyên xử lý các vấn đề
                liên
                quan đến quyền riêng tư, bạn có thể liên hệ với họ qua thông tin ở phần thứ bảy của chính sách quyền riêng tư
                này.
                Chúng tôi sẽ trả lời theo thời gian mà chính sách và luật pháp mỗi nước quy định. Nếu không hài lòng với phản
                hồi
                của chúng tôi, nhất là khi bạn cho rằng việc xử lý thông tin cá nhân của chúng tôi đã xâm hại đến quyền lợi hợp
                pháp
                của mình, bạn cũng có thể giải quyết vấn đề thông qua các kênh bên ngoài như gửi đơn kiện lên tòa án có thẩm
                quyền,
                khiếu nại lên cơ quan quản lý của chính phủ, v.v.</p>
            <p><strong>I. Chúng Tôi Thu Thập Những Thông Tin Gì Và Sử Dụng Chúng Như Thế Nào</strong></p>
            <p>Thông tin cá nhân là các dữ liệu khác nhau được ghi lại dưới dạng điện tử hoặc theo những cách khác có thể xác
                định
                một cá nhân cụ thể thông qua chính thông tin đó hoặc thông qua liên kết với thông tin khác.</p>
            <p>Thông tin cá nhân nhạy cảm là thông tin cá nhân một khi bị rò rỉ, cung cấp bất hợp pháp hoặc sử dụng sai mục đích
                có thể gây nguy hiểm cho sự an toàn của cá nhân và tài sản, dễ dẫn việc cá nhân bị tổn hại về danh tiếng, sức
                khỏe
                thể chất và tinh thần hoặc bị phân biệt đối xử. Bao gồm nhưng không giới hạn ở: số ID, dữ liệu sinh trắc học cá
                nhân, số tài khoản ngân hàng, thông tin tài sản, thông tin hành trình, thông tin giao dịch, thông tin cá nhân
                của
                trẻ em dưới 14 tuổi (bao gồm), v.v.</p>
            <p>Mục đích chính của việc thu thập thông tin cá nhân của chúng tôi là cung cấp cho bạn các sản phẩm và/hoặc dịch
                vụ,
                đồng thời đảm bảo rằng chúng tôi tuân thủ pháp luật, quy định hiện hành và các văn bản quy phạm khác. Bạn có
                quyền
                chọn cung cấp thông tin này hay không, nhưng trong hầu hết các trường hợp, nếu bạn không cung cấp, chúng tôi có
                thể
                không cung cấp cho bạn các dịch vụ tương ứng và không thể phản hồi các vấn đề mà bạn gặp phải.</p>
            <p><strong>(I) Các Trường Hợp Mà Dịch Vụ Dreamehome Cơ Bản Thu Thập Và Xử Lý Thông Tin Cá Nhân Của Bạn</strong></p>
            <p><strong>(1) Ứng dụng Dreamehome kết nối và quản lý thiết bị phần cứng thông minh</strong></p>
            <p>Nhằm cung cấp các dịch vụ Dreamehome giúp bạn có thể kết nối và quản lý thiết bị phần cứng thông minh một cách an
                toàn, chúng tôi có thể thu thập thông tin Wifi, thông tin vị trí, thông tin tài khoản đăng nhập, thông tin liên
                quan
                đến điện thoại di động, thông tin liên quan đến thiết bị phần cứng thông minh và thông tin liên quan của tài
                khoản
                Dreame và thiết bị phần cứng thông minh. Thông tin này sẽ được sử dụng để cung cấp cho bạn các tính năng: kết
                nối
                nhanh, kết nối, phát hiện thiết bị lân cận và quản lý thiết bị cho thiết bị phần cứng thông minh. Các thông tin
                nêu
                trên được liệt kê cụ thể như sau:</p>
            <p>Thông tin tài khoản đăng nhập: tên người dùng, mật khẩu, biệt danh, ảnh đại diện, email, số điện thoại di động
                của
                tài khoản Dreame của bạn. Trong đó: <strong>tên người dùng, mật khẩu, số điện thoại di động và địa chỉ email là
                    thông tin cá nhân nhạy cảm</strong>. Mục đích của việc thu thập thông tin loại này là đăng nhập vào máy chủ
                của
                tài khoản Dreame để xác thực danh tính của người dùng và nhận quyền để tài khoản Dreamehome có thể truy cập vào
                máy
                chủ. Tên tài khoản người dùng và thông tin xác thực mật khẩu đăng nhập bạn nhập sẽ được mã hóa và gửi đến máy
                chủ
                tài khoản Dreame để xác thực đăng nhập. </p>
            <p>Thông tin liên quan đến điện thoại di động: nhận dạng thiết bị phần cứng (IMEI/OAID, địa chỉ Mac, Android ID),
                model điện thoại, thông tin phiên bản hệ điều hành, ngôn ngữ hệ điều hành, quốc gia hoặc khu vực mà điện thoại
                cài
                đặt, kích thước và độ phân giải màn hình điện thoại, các thông tin liên quan đến CPU và thiết bị hiển thị. Mục
                đích
                của việc thu thập loại thông tin này là để ứng dụng Dreamehome có thể kết nối với thiết bị phần cứng thông minh.
            </p>
            <p>Thông tin của thiết bị phần cứng thông minh: tên thiết bị, model, phiên bản, nhà sản xuất, số nhận dạng thiết bị,
                địa chỉ MAC, địa chỉ IP, trạng thái hoạt động của thiết bị, thuộc tính tùy chỉnh, thông số cài đặt, sự kiện kinh
                doanh, hồ sơ sử dụng và quản lý thiết bị. Mục đích của chúng tôi khi thu thập các thông tin loại này là liên kết
                với
                thiết bị phần cứng thông minh để kiểm soát và quản lý thiết bị, đặt thuộc tính và thông số của thiết bị, đồng
                thời
                tra cứu trạng thái và lịch sử làm việc của thiết bị.</p>
            <p><strong>(2) Nâng cấp ứng dụng Dreamehome và thiết bị phần cứng thông minh:</strong></p>
            <p>Nhằm giúp bạn tiếp tục tận hưởng các dịch vụ Dreamehome mới nhất, chúng tôi có thể sử dụng thông tin phiên bản
                của
                ứng dụng Dreamehome và model điện thoại để cung cấp dịch vụ nâng cấp ứng dụng Dreamehome cho bạn. Đồng thời,
                chúng
                tôi có thể thu thập thông tin danh sách và số phiên bản các thiết bị phần cứng thông minh được kết nối để cung
                cấp
                cho bạn tính năng nâng cấp thiết bị phần cứng thông minh nhằm đảm bảo bạn có thể sử dụng phiên bản dịch vụ mới
                nhất
                (bao gồm cả phần mềm cho phần cứng). Dreamehome chỉ cung cấp đường dẫn nâng cấp, phiên bản phần mềm của thiết bị
                phần cứng thông minh do nhà sản xuất thiết bị phần cứng thông minh cung cấp và chịu trách nhiệm về chất lượng
                phiên
                bản và kết quả nâng cấp.</p>
            <p>Nếu không cung cấp loại thông tin này, bạn sẽ không thể nâng cấp lên phiên bản mới của ứng dụng Dreamehome và
                phần
                mềm của thiết bị phần cứng thông minh.</p>
            <p><strong>(3) Trả lời câu hỏi trực tuyến:</strong></p>
            <p>Nhằm giúp bạn giải quyết hiệu quả hơn các sự cố có thể xảy ra trong ứng dụng Dreamehome và thiết bị phần cứng
                thông
                minh, chúng tôi cung cấp cho bạn một kênh trả lời câu hỏi trực tuyến. Để đạt được các tính năng nêu trên, chúng
                tôi
                cần thu thập các thông tin sau từ bạn: thông tin nhật ký của ứng dụng Dreamehome và thiết bị, thông tin liên hệ
                phản
                hồi của bạn và mô tả sự cố, hình ảnh và video hiện tượng sự cố. Trong đó thông tin nhật ký của ứng dụng và thiết
                bị
                bao gồm: trạng thái thiết bị, thông tin thu được từ thiết bị cảm biến, nhật ký vận hành thiết bị, số nhận dạng
                thiết
                bị, v.v. Mục đích của việc thu thập thông tin loại này là để phân tích và xác định nguyên nhân của sự cố; Mục
                đích
                thu thập thông tin liên hệ của bạn là để theo dõi lần phản hồi tiếp theo, tìm hiểu xem vấn đề đã được giải quyết
                hoàn toàn hay chưa, hoặc để liên hệ với bạn, hy vọng bạn có thể bổ sung các thông tin cần thiết khác.</p>
            <p>Chúng tôi sẽ sử dụng thông tin cá nhân của bạn theo cách sau: chỉ sử dụng nhằm mục đích xác định và giải quyết
                các
                vấn đề phản hồi, không hiển thị thông tin cá nhân và không sử dụng nó để quảng cáo thương mại. Nếu bạn không
                cung
                cấp loại thông tin này, chúng tôi sẽ không thể xác định và giải quyết các vấn đề mà bạn đã phản hồi một cách
                hiệu
                quả.</p>
            <p><strong>(II) Các Trường Hợp Chúng Tôi Thu Thập Và Xử Lý Thông Tin Cá Nhân Của Bạn Ngoài Việc Cung Cấp Các Dịch Vụ
                Dreamehome Cơ Bản</strong></p>
            <p>Ngoài các dịch vụ cơ bản mà Dreamehome sẽ sử dụng thông tin cá nhân, các tính năng bổ sung sau đây cũng có thể
                thu
                thập và sử dụng thông tin cá nhân của bạn. Nếu không cung cấp các thông tin cá nhân này thì bạn vẫn có thể sử
                dụng
                các dịch vụ cơ bản của Dreamehome, nhưng có thể không sử dụng các tính năng bổ sung có thể mang lại sự tiện lợi
                này.
                Các tính năng bổ sung này bao gồm:</p>
            <p><strong>Kế hoạch cải thiện trải nghiệm người dùng:</strong></p>
            <p>Để cải thiện trải nghiệm người dùng, chúng tôi cần thu thập các thông tin sau từ bạn: nhật ký Dreamehome, trong
                đó
                bao gồm các loại thông tin đã được mã hóa như nhật ký quy trình chính, nhật ký sự kiện, nhật ký lỗi, sự kiện tác
                vụ,
                tình hình sử dụng các giao diện ứng dụng, v.v. Bên trong nhật ký sẽ không ghi lại các thông tin nhạy cảm của
                bạn.
            </p>
            <p>Chúng tôi sẽ sử dụng thông tin cá nhân của bạn theo cách sau: tự động thu thập các thông tin nêu trên và tải lên
                máy chủ, phân tích thông tin nhật ký để chẩn đoán trạng thái hoạt động của thiết bị và phân tích việc sử dụng
                ứng
                dụng.</p>
            <p>Nếu không cung cấp thông tin này, Dreamehome sẽ không thể cải thiện trải nghiệm người dùng của bạn một cách kịp
                thời, nhưng điều này sẽ không ảnh hưởng đến các chức năng cơ bản của dịch vụ.</p>
            <p> <strong>(III) Các Trường Hợp Mà Chúng Tôi Lấy Thông Tin Cá Nhân Của Bạn Từ Bên Thứ Ba</strong></p>
            <p>Trong một số trường hợp mà pháp luật cho phép, chúng tôi có thể lấy thông tin cá nhân của bạn từ bên thứ ba. Ví
                dụ:
            </p>
            <p>1. Trong điều kiện bạn cho phép, chúng tôi sẽ tiến hành hợp tác với các nhà cung cấp dịch vụ bên thứ ba trong
                việc
                quản lý thiết bị phần cứng thông minh của bên thứ ba, trong đó bao gồm việc chúng tôi lấy thông tin cá nhân của
                bạn
                từ các nhà cung cấp dịch vụ bên thứ ba. Trong việc quản lý thiết bị của bên thứ ba, chúng tôi sẽ lấy các thông
                tin
                cá nhân sau về bạn với điều kiện bạn liên kết tài khoản của bên thứ ba:</p>
            <p>Thông tin tài khoản bên thứ ba, bao gồm biệt danh và ảnh đại diện của bạn, được sử dụng để hiển thị trong ứng
                dụng
                Dreamehome;</p>
            <p>Thông tin về thiết bị và mạng, bao gồm: số nhận dạng thiết bị, địa chỉ MAC và số sêri của thiết bị, được sử dụng
                để
                xác định thiết bị hiện đang hoạt động và thực hiện kiểm soát bảo mật thiết bị.</p>
            <p>Nếu hoạt động xử lý thông tin cá nhân mà chúng tôi cần thực hiện khi triển khai các nghiệp vụ nằm ngoài phạm vi
                cho
                phép và đồng ý ban đầu của bạn khi cung cấp thông tin cá nhân cho các nhà cung cấp dịch vụ bên thứ ba, chúng tôi
                sẽ
                xin phép sự đồng ý rõ ràng của bạn trước khi xử lý thông tin cá nhân này. Ngoài ra, chúng tôi cũng sẽ tuân thủ
                nghiêm ngặt pháp luật và quy định có liên quan, đồng thời yêu cầu các nhà cung cấp dịch vụ bên thứ ba đảm bảo
                tính
                hợp pháp của thông tin mà họ cung cấp.</p>
            <p><strong>(IV) Thông Tin Phi Cá Nhân</strong></p>
            <p>Chúng tôi cũng có thể thu thập các thông tin không thể xác định được cá nhân cụ thể (tức không phải thông tin cá
                nhân), chẳng hạn như dữ liệu thống kê được tạo ra khi bạn sử dụng một dịch vụ cụ thể, chẳng hạn như thói quen
                thao
                tác của người dùng (bao gồm nhấp chuột, chuyển trang, thời gian duyệt web). Mục đích của việc thu thập loại
                thông
                tin này là để cải thiện các dịch vụ mà chúng tôi cung cấp cho bạn. Loại và số lượng thông tin được thu thập tùy
                thuộc vào cách bạn sử dụng sản phẩm và/hoặc dịch vụ của chúng tôi. Chúng tôi sẽ tổng hợp loại thông tin này để
                cung
                cấp thêm thông tin hữu ích cho khách hàng. Giúp chúng tôi hiểu phần nào trên website, sản phẩm và dịch vụ được
                khách
                hàng quan tâm nhất, nhằm chúng tôi tối ưu hóa giao diện dịch vụ của mình. Đối với chính sách quyền riêng tư này,
                dữ
                liệu tổng hợp được xem là thông tin phi cá nhân. Nếu chúng tôi kết hợp thông tin phi cá nhân với thông tin cá
                nhân,
                thì loại thông tin này sẽ được coi là thông tin cá nhân trong thời gian kết hợp sử dụng.</p>
            <p><strong>II. Cách Chúng Tôi Sử Dụng Cookie Và Các Công Nghệ Tương Tự</strong></p>
            <p>Để đảm bảo Dreamehome có thể hoạt động bình thường, chúng tôi sẽ lưu trữ một tệp dữ liệu nhỏ có tên Cookie trên
                thiết bị của bạn. Cookie thường chứa: số nhận dạng, tên trang web và một số chữ số và ký tự. Nhờ sự hỗ trợ của
                Cookie, Dreamehome có thể lưu trữ tài khoản đăng nhập trang web, sở thích và các dữ liệu khác của bạn.</p>
            <p>Chúng tôi sẽ không sử dụng Cookie cho bất kỳ mục đích nào khác ngoài những mục đích được nêu trong tuyên bố này.
                Bạn có thể quản lý hoặc xóa Cookie tùy theo sở thích của mình. Nhưng nếu làm như vậy, trong một số trường hợp có
                thể
                ảnh hưởng đến sự truy cập an toàn của bạn vào Dreamehome và bạn có thể cần phải tự mình thay đổi cài đặt người
                dùng
                mỗi khi truy cập Dreamehome.</p>
            <p><strong>III. </strong><strong>Cách Chúng Tôi Ủy Thác Việc Xử Lý, Chia Sẻ, Chuyển Giao Và Tiết Lộ Công Khai Thông
                Tin Cá Nhân Của Bạn?</strong></p>
            <p><strong>(I) Ủy Quyền Xử Lý</strong></p>
            <p>Trong các tình huống thông thường, Dreame có thể ủy thác các công ty khác thay mặt chúng tôi xử lý thông tin cá
                nhân của bạn. Ví dụ: các công ty thay mặt chúng tôi liên hệ, gửi email hoặc cung cấp hỗ trợ kỹ thuật cho bạn.
                Các
                công ty này chỉ có thể sử dụng thông tin cá nhân của bạn để thay mặt chúng tôi cung cấp dịch vụ cho bạn.</p>
            <p>Chúng tôi sẽ ký một thỏa thuận bảo mật nghiêm ngặt hoặc điều khoản xử lý thông tin cá nhân với bên được ủy thác,
                đồng thời yêu cầu họ xử lý thông tin cá nhân theo chính sách quyền riêng tư này và áp dụng các biện pháp bảo mật
                và
                an toàn có liên quan.</p>
            <p><strong>(II) Chia Sẻ</strong></p>
            <p>Trong các tình huống thông thường, chúng tôi sẽ không chia sẻ thông tin cá nhân của bạn với bên ngoài, ngoại trừ
                các trường hợp sau:</p>
            <p>1. Sau khi được sự đồng ý rõ ràng của bạn, chúng tôi sẽ chia sẻ thông tin trong phạm vi cho phép của bạn với bên
                thứ ba do bạn chỉ định; Bao gồm cả việc chia sẻ thông tin và cấu hình các sản phẩm gia dụng thông minh của bạn
                với
                người thân và bạn bè theo yêu cầu của bạn. Để giúp họ nhanh chóng sử dụng phần mềm và dịch vụ này thông qua
                thiết bị
                đầu cuối của mình.</p>
            <p>2. Một phần nội dung của dịch vụ Dreamehome do các nhà cung cấp dịch vụ bên thứ ba phụ trách, do đó chúng tôi cần
                cung cấp một phần thông tin cá nhân của bạn cho họ. Chẳng hạn như ủy thác lưu trữ website, phân tích dữ liệu, xử
                lý
                thanh toán và thẻ tín dụng, cung cấp cơ sở hạ tầng, dịch vụ CNTT, dịch vụ hỗ trợ chăm sóc khách hàng, dịch vụ
                gửi
                email và các dịch vụ tương tự khác nhằm đảm bảo họ có thể cung cấp dịch vụ cho chúng tôi.</p>
            <p>3. Tiết lộ thông tin cá nhân của bạn cho khách hàng và các đối tác nghiệp vụ khác, những người trực tiếp hoặc
                gián
                tiếp cung cấp cho bạn các thiết bị phần cứng thông minh và/hoặc các mạng và hệ thống mà bạn sử dụng để truy cập,
                sử
                dụng website và dịch vụ của chúng tôi.</p>
            <p>4. Trong trường hợp tổ chức lại, sáp nhập, bán, liên doanh, nhượng lại, chuyển giao hoặc xử lý khác đối với toàn
                bộ
                hoặc một phần hoạt động kinh doanh, tài sản hoặc cổ phiếu của chúng tôi (Bao gồm nhưng không giới hạn ở các
                trường
                hợp nêu trên liên quan đến bất kỳ thủ tục phá sản hoặc tương tự), tiết lộ thông tin cá nhân của bạn cho công ty
                liên
                kết hoặc bên thứ ba khác. Trong trường hợp này, bạn sẽ nhận được thông báo rõ ràng qua email và/hoặc website của
                chúng tôi về việc thay đổi quyền sở hữu, sự không tương thích của phương thức sử dụng thông tin cá nhân mới và
                các
                lựa chọn có liên quan về thông tin cá nhân.</p>
            <p>5. Trong trường hợp chúng tôi cho là cần thiết hoặc thỏa đáng: (a) Tuân thủ pháp luật và quy định hiện hành; (b)
                Tuân thủ các thủ tục pháp lý; (c) Đáp ứng các yêu cầu của cơ quan công cộng và cơ quan chính phủ, bao gồm cả
                những
                cơ quan công cộng và cơ quan chính phủ bên ngoài quốc gia/khu vực nơi bạn sinh sống; (d) Thực hiện các điều
                khoản và
                điều kiện của chúng tôi; (e) Bảo vệ hoạt động, kinh doanh và hệ thống của chúng tôi; (f) Bảo vệ quyền lợi, sự
                riêng
                tư, an toàn hoặc tài sản của chúng tôi và/hoặc những người dùng khác bao gồm cả bạn; và (g) Tìm kiếm các biện
                pháp
                khắc phục có thể hoặc hạn chế các thiệt hại mà chúng tôi có thể phải bồi thường.</p>
            <p>6. Tiết lộ thông tin cá nhân của bạn cho các công ty con hoặc công ty liên kết để triển khai hoạt động kinh doanh
                một cách định kỳ.</p>
            <p>7. Chúng tôi sẽ chia sẻ dữ liệu cần thiết với bên thứ ba thông qua Giao Diện Lập Trình Ứng Dụng (API), Bộ Công Cụ
                Phát Triển Phần Mềm (SDK). Các phiên bản SDK khác nhau của bên thứ ba sẽ có sự khác nhau. Thông thường bao gồm
                đăng
                nhập tài khoản của bên thứ ba, chia sẻ, thanh toán của bên thứ ba, thông tin đẩy của nhà sản xuất, số liệu thống
                kê,
                v.v. Chúng tôi sẽ tiến hành kiểm tra bảo mật nghiêm ngặt đối với bên thứ ba và quy định về các biện pháp bảo vệ
                dữ
                liệu. Bảng 1 là thông tin chi tiết về SDK của bên thứ ba mà chúng tôi đã cho phép truy cập, vui lòng đọc kỹ.
                Chính
                sách quyền riêng tư của chúng tôi không áp dụng cho các sản phẩm hoặc dịch vụ do bên thứ ba cung cấp. Khi bạn sử
                dụng các sản phẩm hoặc dịch vụ này, cũng có thể bị thu thập thông tin của mình. Do đó, chúng tôi đặc biệt khuyên
                bạn
                nên dành thời gian để đọc kỹ chính sách quyền riêng tư của bên thứ ba, giống như khi đọc chính sách của chúng
                tôi.
                Chúng tôi không chịu trách nhiệm về cách thức bên thứ ba sử dụng thông tin cá nhân mà họ thu thập từ bạn, cũng
                như
                không thể kiểm soát việc sử dụng của họ. Chính sách quyền riêng tư của chúng tôi không áp dụng cho các website
                khác
                được liên kết thông qua dịch vụ của chúng tôi. Bạn cần tự đánh giá độc lập sự tương tác của mình với các webstie
                được liên kết. Trong lần đầu tiên khi bạn truy cập website của bên thứ ba, nhà cung cấp dịch vụ bên thứ ba sẽ
                hiển
                thị cho bạn các thỏa thuận và tuyên bố về quyền riêng tư có liên quan, vui lòng đọc kỹ các thỏa thuận và tuyên
                bố về
                quyền riêng tư này.</p>
            <p><strong>(III) Chuyển Giao</strong></p>
            <p>Dreame sẽ không chuyển giao thông tin cá nhân của bạn cho bất kỳ công ty, tổ chức hay cá nhân nào, trừ các trường
                hợp sau:</p>
            <p>1. Chuyển giao khi có sự đồng ý rõ ràng: Sau khi nhận được sự đồng ý rõ ràng của bạn, chúng tôi sẽ chuyển thông
                tin
                cá nhân của bạn cho các bên khác;</p>
            <p>2. Khi liên quan đến sáp nhập, mua lại hoặc thanh lý phá sản, nếu liên quan đến việc chuyển giao thông tin cá
                nhân,
                chúng tôi sẽ yêu cầu công ty hoặc tổ chức mới nắm giữ thông tin cá nhân của bạn tiếp tục bị ràng buộc bởi tuyên
                bố
                này, nếu không chúng tôi sẽ yêu cầu họ trưng cầu sự đồng ý và cho phép của bạn.</p>
            <p><strong>(IV) Tiết Lộ Và Công Khai</strong></p>
            <p>Chúng tôi chỉ tiết lộ và công khai thông tin cá nhân của bạn trong các trường hợp sau:</p>
            <p>1. Sau khi nhận được sự đồng ý rõ ràng từ bạn;</p>
            <p>2. Tiết lộ dựa trên pháp luật: Chúng tôi có thể tiết lộ và công khai thông tin cá nhân của bạn theo quy định của
                pháp luật hoặc dựa trên các thủ tục pháp lý, tố tụng hoặc yêu cầu bắt buộc của cơ quan chính phủ.</p>
            <p><strong>IV. Cách Chúng Tôi Lưu Trữ Và Bảo Vệ Thông Tin Cá Nhân Của Bạn </strong></p>
            <p>Chúng tôi sẽ lưu giữ thông tin cá nhân trong khoảng thời gian cần thiết cho mục đích thu thập thông tin được mô
                tả
                trong chính sách quyền riêng tư này hoặc tuân thủ theo các yêu cầu pháp lý hiện hành. Sau khi hoàn thành mục
                đích
                thu thập, hoặc sau khi chúng tôi xác nhận việc xóa hoặc đơn đăng ký hủy của bạn hoặc sau khi chúng tôi chấm dứt
                hoạt
                động của sản phẩm hoặc dịch vụ tương ứng, chúng tôi sẽ ngừng lưu trữ, đồng thời xóa hoặc xử lý ẩn danh các thông
                tin
                này. Nếu xuất phát từ lợi ích công cộng, nghiên cứu khoa học, lịch sử hoặc mục đích thống kê, chúng tôi sẽ tiếp
                tục
                lưu trữ các dữ liệu có liên quan dựa theo pháp luật hiện hành, ngay cả khi các bước xử lý dữ liệu tiếp theo
                không
                liên quan với mục đích thu thập ban đầu.</p>
            <p>Trong các nghiệp vụ Dreamehome, thời gian lưu trữ dữ liệu cá nhân cụ thể của bạn như sau:</p>
            <p>Đối với dữ liệu được lưu trữ cục bộ trong ứng dụng Dreamehome, khi bạn gỡ cài đặt hoặc xóa dữ liệu ứng dụng
                Dreamehome, tất cả dữ liệu đã lưu trữ sẽ được xóa ngay lập tức.</p>
            <p>Đối với dữ liệu thiết bị phần cứng thông minh và dịch vụ Dreamehome được lưu trên máy chủ, khi bạn xóa thiết bị
                phần cứng thông minh, từ chối đồng ý với chính sách quyền riêng tư và ngừng sử dụng dịch vụ của Dreamehome, tất
                cả
                dữ liệu đã lưu trữ sẽ được xóa ngay lập tức.</p>
            <p>Đối với nhật ký dịch vụ, dữ liệu thống kê, ghi chép lịch sử được lưu trữ trên máy chủ, chúng tôi sẽ xóa chúng khi
                tiến hành dọn dẹp không định kỳ dữ liệu trên máy chủ và thời gian lưu trữ dữ liệu thường không quá 2 năm.</p>
            <p>Ngoài ra, trong trường hợp sản phẩm hoặc dịch vụ của chúng tôi ngừng hoạt động, chúng tôi sẽ báo cho bạn biết
                dưới
                dạng thông báo đẩy, thông cáo, v.v. Đồng thời xóa thông tin cá nhân của bạn hoặc xử lý ẩn danh chúng trong một
                khoảng thời gian hợp lý.</p>
            <p><strong>V. Quyền Lợi Của Bạn</strong></p>
            <p><strong>(I) Truy Cập, Chỉnh Sửa, Xóa Thông Tin Cá Nhân Của Bạn</strong></p>
            <p>Căn cứ theo pháp luật và quy định hiện hành ở quốc gia hoặc khu vực của bạn, bạn có quyền yêu cầu truy cập, chỉnh
                sửa và xóa bất kỳ thông tin cá nhân nào mà chúng tôi có về bạn (sau đây gọi là yêu cầu). Hãy gửi thư hoặc liên
                hệ
                với chúng tôi bằng cách truy cập Dreamehome. Hầu hết các luật đòi hỏi yêu cầu của chủ thể thông tin cá nhân phải
                tuân theo các quy định cụ thể. Chính sách quyền riêng tư này đòi hỏi yêu cầu của bạn phải thỏa các trường hợp
                sau:
            </p>
            <p>Thông qua các kênh yêu cầu chuyên dụng của chúng tôi, đồng thời nhằm bảo đảm an toàn cho thông tin của bạn, yêu
                cầu
                của bạn phải ở dạng văn bản (trừ khi luật pháp nước sở tại công nhận rõ ràng có thể yêu cầu bằng miệng);</p>
            <p>Cung cấp đầy đủ thông tin để chúng tôi có thể xác minh thân phận của bạn, đảm bảo người yêu cầu là chủ thể hoặc
                là
                người được ủy quyền hợp pháp của thông tin được yêu cầu;</p>
            <p>Khi đã có đầy đủ thông tin để xác nhận có thể xử lý yêu cầu của bạn, chúng tôi sẽ phản hồi yêu cầu của bạn trong
                thời gian được quy định bởi luật bảo vệ dữ liệu hiện hành. Cụ thể như sau:</p>
            <p>Dựa trên yêu cầu của bạn và pháp luật, quy định hiện hành, chúng tôi có thể cung cấp miễn phí một bản ghi chép
                thông tin cá nhân của bạn mà chúng tôi đã thu thập và xử lý. Nếu bạn đưa ra các yêu cầu khác về thông tin liên
                quan,
                chúng tôi có thể tính phí hợp lý cho bạn dựa trên luật hiện hành có liên quan và kết hợp với chi phí quản lý
                thực
                tế.</p>
            <p>Nếu bạn cho rằng bất kỳ thông tin nào chúng tôi nắm giữ về bạn là chưa chính xác hoặc không đầy đủ, bạn có thể
                yêu
                cầu chỉnh sửa hoặc hoàn thiện thông tin cá nhân của mình dựa trên mục đích sử dụng.</p>
            <p>Căn cứ theo pháp luật và quy định được áp dụng cho bạn, bạn có thể có quyền yêu cầu chúng tôi xóa dữ liệu cá nhân
                của mình. Chúng tôi sẽ đánh giá yêu cầu xóa của bạn, nếu đáp ứng quy định, chúng tôi sẽ thực hiện các bước tương
                ứng
                bao gồm các biện pháp kỹ thuật để tiến hành giải quyết. Khi bạn hoặc chúng tôi hỗ trợ bạn xóa thông tin có liên
                quan, do pháp luật hiện hành và công nghệ bảo mật, chúng tôi có thể không xóa thông tin tương ứng khỏi hệ thống
                sao
                lưu ngay lập tức. Chúng tôi sẽ lưu trữ an toàn thông tin cá nhân của bạn và cách ly nó khỏi tất cả các quá trình
                xử
                lý cho đến khi bản sao lưu có thể bị xóa hoặc xử lý ẩn danh. Ví dụ: Căn cứ "Luật Thương Mại Điện Tử của Cộng Hòa
                Nhân Dân Trung Hoa", thông tin sản phẩm và dịch vụ, thông tin giao dịch của bạn phải được lưu ít nhất ba năm kể
                từ
                ngày hoàn thành giao dịch.</p>
            <p>Chúng tôi có quyền từ chối xử lý các yêu cầu lặp đi lặp lại không có ý nghĩa thực tế/vướng víu, các yêu cầu gây
                tổn
                hại đến quyền riêng tư của người khác, các yêu cầu cực kỳ phi thực tế, các yêu cầu đòi hỏi công việc kỹ thuật
                không
                tương xứng và các yêu cầu không cần phải thực hiện theo pháp luật nước sở tại, thông tin đã được công khai,
                thông
                tin được đưa ra trong điều kiện bảo mật. Nếu chúng tôi cho rằng một số khía cạnh nhất định của yêu cầu xóa hoặc
                truy
                cập dữ liệu có thể ngăn chúng tôi sử dụng hợp pháp dữ liệu cho mục đích chống gian lận và bảo mật nói trên,
                chúng
                tôi cũng có thể từ chối nó.</p>
            <p><strong>(II) Rút Lại Sự đồng Ý</strong></p>
            <p>Bạn có thể rút lại sự đồng ý của mình bằng cách gửi yêu cầu, bao gồm: việc thu thập, sử dụng và/hoặc tiết lộ
                thông
                tin cá nhân của bạn mà chúng tôi nắm giữ hoặc kiểm soát. Căn cứ vào dịch vụ cụ thể mà mình sử dụng, bạn có thể
                dùng
                thông tin liên hệ trong Phần 7 của chính sách quyền riêng tư này để liên hệ với chúng tôi nhằm tiến hành các
                thao
                tác có liên quan. Sau khi bạn đưa ra yêu cầu, chúng tôi sẽ xử lý nó trong một thời gian hợp lý, đồng thời căn cứ
                theo yêu cầu của bạn ngừng việc thu thập, sử dụng và/hoặc tiết lộ thông tin cá nhân của bạn.</p>
            <p>Vui lòng lưu ý, tùy thuộc vào phạm vi bạn đã ủy quyền để chúng tôi xử lý thông tin, việc rút lại sự đồng ý có thể
                khiến bạn không thể sử dụng Dreamehome hoặc các dịch vụ từ sản phẩm phần cứng thông minh của nó. Nhưng quyết
                định
                rút lại sự đồng ý hoặc ủy quyền này sẽ không ảnh hưởng đến quá trình xử lý thông tin cá nhân trước đó dựa trên
                sự ủy
                quyền của bạn.</p>
            <p>Bạn có thể rút lại sự đồng ý của mình đối với việc sử dụng thông tin cá nhân bằng cách yêu cầu rút lại sự đồng ý
                hoặc vào trang Dreamehome thực hiện các thay đổi để thoát khỏi kế hoạch cải thiện trải nghiệm người dùng.</p>
            <p><strong>(III) Hủy Tài Khoản Dreamehome</strong></p>
            <p>Bạn có thể hủy tài khoản Dreamehome bằng cách truy cập "Của Tôi" - "Cài Đặt Tài Khoản" - "Hủy Tài Khoản". Nếu bạn
                muốn hủy tài khoản Dreamehome của mình, thao tác hủy này sẽ khiến bạn không thể sử dụng Dreamehome và toàn bộ
                dòng
                sản phẩm, dịch vụ phần cứng thông minh của nó. Vui lòng cân nhắc kỹ trước khi thực hiện. Để bảo vệ quyền và lợi
                ích
                hợp pháp của bạn hoặc người khác, chúng tôi sẽ dựa trên việc sử dụng các sản phẩm và dịch vụ phần cứng thông
                minh
                Dreamehome của bạn để xác định xem có hỗ trợ yêu cầu hủy của bạn hay không.</p>
            <p><strong>VI. Truyền Dữ Liệu Xuyên Biên Giới</strong></p>
            <p>Do chúng tôi cung cấp sản phẩm hoặc dịch vụ thông qua các tài nguyên và máy chủ trên toàn thế giới, điều này có
                nghĩa là sau khi nhận được sự cho phép và đồng ý của bạn, thông tin cá nhân của bạn có thể được chuyển đến hoặc
                truy
                cập từ các khu vực pháp lý nằm ngoài quốc gia/khu vực nơi bạn sử dụng sản phẩm hoặc dịch vụ. Các biện pháp và
                điều
                luật bảo vệ dữ liệu của quốc gia/khu vực nơi thông tin của bạn có thể được chuyển đến có thể không toàn diện như
                quốc gia/khu vực của bạn. Trong trường hợp này, chúng tôi sẽ thực hiện các biện pháp thích hợp và hợp pháp theo
                pháp
                luật hiện hành của từng khu vực tài phán để đảm bảo rằng thông tin cá nhân của bạn tiếp tục được bảo vệ.</p>
            <p>Lưu ý đặc biệt:</p>
            <p>Nếu bạn là cư dân của Liên minh Châu Âu (EEA) và thông tin cá nhân của bạn được chuyển ra ngoài EEA, chúng tôi
                sẽ:
                xử lý thông tin cá nhân của bạn ở khu vực mà Ủy ban Châu Âu đã xác định là cung cấp đủ mức độ bảo vệ; Hoặc thực
                hiện
                các biện pháp thích hợp để bảo vệ thông tin cá nhân của bạn, bao gồm việc truyền tải dữ liệu theo các cơ chế
                hiện
                hành, như các điều khoản hợp đồng tiêu chuẩn của Ủy ban Châu Âu.</p>
            <p><strong>VII. Liên Hệ Với Chúng Tôi</strong></p>
            <p>Nếu bạn có bất kỳ ý kiến hoặc câu hỏi nào về chính sách quyền riêng tư này, hoặc bất kỳ câu hỏi nào về việc chúng
                tôi thu thập, sử dụng hoặc tiết lộ thông tin cá nhân của bạn, vui lòng liên hệ với chúng tôi theo địa chỉ bên
                dưới
                hoặc bằng cách truy cập "Của Tôi" - "Theo Dõi và Phản Hồi", và đề cập "Chính sách quyền riêng tư". Chúng tôi có
                một
                đội ngũ chuyên nghiệp phụ trách giải quyết, đáp ứng các yêu cầu về quyền lợi, tư vấn liên quan đến thông tin cá
                nhân
                của bạn. Nếu câu hỏi liên quan đến các vấn đề quan trọng hơn, chúng tôi có thể yêu cầu bạn cung cấp thêm thông
                tin.
                Nếu không hài lòng với phản hồi nhận được, bạn có thể chuyển đơn khiếu nại của mình đến cơ quan giám sát có liên
                quan trong khu vực tài phán của mình. Nếu bạn tham khảo ý kiến ​​của chúng tôi, chúng tôi sẽ dựa trên tình hình
                thực
                tế của bạn cung cấp thông tin về các kênh khiếu nại thích hợp.</p>
            <p><strong>Địa chỉ email:</strong></p>
            <ul>
                <li>Địa chỉ liên hệ khu vực Trung Quốc: <a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></li>
                <li>Địa chỉ liên hệ DPO Singapore: <a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                <li>Địa chỉ liên hệ của đại diện EU: <a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
            </ul>
            <p><strong>Số điện thoại liên lạc: </strong>400-875-9511</p>
            <p><strong>Website: </strong><a className="page"
                href="https://www.dreametech.com">https://www.dreametech.com</a></p>
            <p><strong>VIII. Cách Cập Nhật Chính Sách Quyền Riêng Tư Này</strong></p>
            <p>Dreame bảo lưu quyền cập nhật chính sách này kịp thời, khi chính sách có thay đổi, chúng tôi sẽ thông qua cửa sổ
                bật lên hoặc các phương thức nổi bật khác hiển thị cho bạn chính sách đã thay đổi. Chỉ sau khi nhận được sự đồng
                ý
                của bạn, chúng tôi mới thu thập, sử dụng và lưu trữ thông tin cá nhân của bạn theo chính sách đã cập nhật.</p>
            <p>Chính sách này có hiệu lực kể từ ngày cập nhật.</p>
            <p>Ngày cập nhật lần cuối: ngày 28 tháng 8 năm 2021</p>
            <p><strong>Bảng 1: Thông tin chi tiết về SDK của bên thứ ba</strong></p>
            <p>* Nhằm cung cấp cho bạn các dịch vụ tính năng cơ bản và bổ sung chuyên nghiệp và an toàn hơn, Dreamehome sẽ tiếp
                nhận sản phẩm SDK của bên thứ ba. Các sản phẩm SDK của bên thứ ba hiện đang có trong Dreamehome được tiết lộ như
                sau:</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>Dịch vụ SDK</p>
                        </td>
                        <td>
                            <p>Tính năng cụ thể</p>
                        </td>
                        <td>
                            <p>Lấy thông tin</p>
                        </td>
                        <td>
                            <p>Chính sách quyền riêng tư của bên thứ ba</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Phân tích thống kê SDK của Youmeng</p>
                        </td>
                        <td>
                            <p>Phân tích thống kê</p>
                        </td>
                        <td>
                            <p>Số nhận dạng thiết bị (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, thông tin IMSI thẻ SIM), vị trí địa lý
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Tin nhắn đẩy SDK của Youmeng</p>
                        </td>
                        <td>
                            <p>Tin nhắn đẩy</p>
                        </td>
                        <td>
                            <p>Số nhận dạng thiết bị (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, thông tin IMSI thẻ SIM), vị trí địa lý
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Chia sẻ xã hội hóa SDK của Youmeng</p>
                        </td>
                        <td>
                            <p>Chia sẻ bên thứ ba</p>
                        </td>
                        <td>
                            <p>Số nhận dạng thiết bị (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, thông tin IMSI thẻ SIM), vị trí địa lý
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>Liên kết micrô, phát video trực tuyến</p>
                        </td>
                        <td>
                            <p>Thông tin thiết bị, trạng thái mạng, máy ảnh, micrô, không gian lưu trữ đọc ghi</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Tin nhắn đẩy SDK của Huawei</p>
                        </td>
                        <td>
                            <p>Tin nhắn đẩy</p>
                        </td>
                        <td>
                            <p>Thông tin nhận dạng thiết bị</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Tin nhắn đẩy SDK của Xiaomi</p>
                        </td>
                        <td>
                            <p>Tin nhắn đẩy</p>
                        </td>
                        <td>
                            <p>Thông tin nhận dạng thiết bị, model thiết bị, loại mạng, bộ nhớ thiết bị, thông tin quy trình chạy
                                thiết bị,
                                phiên bản ứng dụng, phiên bản SDK</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Tin nhắn đẩy SDK của OPPO</p>
                        </td>
                        <td>
                            <p>Tin nhắn đẩy</p>
                        </td>
                        <td>
                            <p>Thông tin nhận dạng thiết bị</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Tin nhắn đẩy SDK của VIVO</p>
                        </td>
                        <td>
                            <p>Tin nhắn đẩy</p>
                        </td>
                        <td>
                            <p>Thông tin nhận dạng thiết bị</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>WeChat SDK</p>
                        </td>
                        <td>
                            <p>Đăng nhập WeChat bên thứ ba, chia sẻ qua WeChat</p>
                        </td>
                        <td>
                            <p>Thông tin nhận dạng thiết bị, thông tin mạng</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>Chia sẻ</p>
                        </td>
                        <td>
                            <p>Thông tin nhận dạng thiết bị, thông tin mạng</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Weibo SDK</p>
                        </td>
                        <td>
                            <p>Đăng nhập Weibo bên thứ ba, chia sẻ qua Weibo</p>
                        </td>
                        <td>
                            <p>Thông tin nhận dạng thiết bị, thông tin mạng</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>AppleID SDK</p>
                        </td>
                        <td>
                            <p>Sử dụng Apple ID để đăng nhập</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.Apple.com/legal/privacy/szh/">https://www.Apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='height'></div>

        </div>
    )
}

export default PricacyPolicy